export const CREDITS_SET = 'CREDITS_SET';
